import { pink, teal } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f59e0b"
    },
    secondary: {
      main: "#7e22ce"
    }
  }
});

export default theme;
